<img *ngIf="(user | avatarType) === 'image'; else svg" [src]="user | avatar : tempName" alt="" />
<ng-template #svg>
  <div [innerHTML]="sanitization.bypassSecurityTrustHtml(user | avatar : tempName)"></div>
</ng-template>
